var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.displayAsConstant)?_c('mmf-dim-search',{attrs:{"value":_vm.value,"entity":_vm.options,"validate":_vm.config.validate,"bindId":_vm.config.bindId,"bindProp":_vm.config.bindProp,"submitProp":_vm.config.submitProp},on:{"input":_vm.updateValue}}):_vm._e(),(_vm.displayAsConstant)?_c('span',[_vm._v(_vm._s(_vm.showValue))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }